import { FormContent } from '../../../components/bookingConfirmationCard/bookingConfirmationFun';

export default function AccCompany({ accDetails }) {
    console.log(accDetails);
    return (
        <div>
            <h2 className='orgAccountH2'>Company Details</h2>
            <div className='orgAccountSecDiv'>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Company Name'
                        answer={accDetails?.companyName}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='About'
                        answer={accDetails?.about}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Company Type'
                        answer={accDetails?.typeofCompany}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='GST'
                        answer={accDetails?.gst}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='CIN'
                        answer={accDetails?.cin}
                        className='borderNone width50'
                    />
                    <FormContent
                        id='orgExtraStyle'
                        label='Country Code'
                        answer={accDetails?.countryCode}
                        className='borderNone width50'
                    />
                </div>
                <div className='orgAccountGrid'>
                    <FormContent
                        id='orgExtraStyle'
                        label='Phone Number'
                        answer={accDetails?.phoneNumber}
                        className='borderNone width50'
                    />
                </div>
            </div>
        </div>
    );
}
